import React, { useState, useCallback } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Formik, Form } from 'formik';
import {
  Box,
  Button,
  Grid,
  Container,
  Typography,
  makeStyles,
  CircularProgress
} from "@material-ui/core";

import { manufacturerSchema } from "../../utils/schemas/manufacturerSchema";
import FormField from "../FormField/FormField";
import ProviderRegisterStyle from "./ProviderRegisterStyle";
import { Creators as ManufacturerActions } from "../../store/ducks/manufacturer";
import { COLORS } from "../../utils/js/constants";

const useStyles = makeStyles((theme) => ProviderRegisterStyle(theme));

const ProviderRegister = ({ onFinished, manufacturerDataToEdit, manufacturer, createManufacturer, updateManufacturer }) => {
    const [loading, setLoading] = useState(false)
    const [manufacturerState, setManufacturerState] = useState(null)

    const classes = useStyles();

    const handleSubmit = useCallback((manufacturer) => {

        setLoading(true)

        setManufacturerState(manufacturerState)

        if (manufacturerDataToEdit?.codigo) {
            updateManufacturer(manufacturer)
            onFinished()
        }else{
            createManufacturer(manufacturer)
            onFinished()
        }
    }, [onFinished, setLoading, createManufacturer, manufacturer, setManufacturerState, manufacturerState, updateManufacturer, manufacturerDataToEdit])

    const submitBtnTitle = () => manufacturerDataToEdit?.codigo ? "Finalizar Edição" : "Finalizar Cadastro";

    const loadingElement = () => (
        <>
            <span> Aguarde </span>
            <CircularProgress color={COLORS.white} size={12} />
        </>
    )

    return (
        <Box className={classes.root}>
            <Typography className={classes.title} variant="h6" component="h2">
                Digite as informações do Fornecedor
            </Typography>

            <Formik
                initialValues={{ 
                    ...manufacturerSchema.getDefaultFromShape(), 
                    ...manufacturerDataToEdit 
                }}
                validationSchema={manufacturerSchema}
                onSubmit={(values) => handleSubmit(values)}
            >{() => (
                <Form>
                    <Grid container justify="space-between" spacing={0}>
                        <Grid item>
                            <FormField
                                name="nome"
                                type="text"
                                label="Nome do Fornecedor"
                                variant="outlined"
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item>
                            <FormField
                                name="codigo"
                                type="text"
                                label="Código do Fornecedor"
                                variant="outlined"
                                fullWidth
                                required
                            />
                        </Grid> 

                        <Grid item>
                            <FormField
                                name="contato"
                                type="text"
                                label="Telefone"
                                variant="outlined"
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item>
                            <FormField
                                name="email"
                                type="text"
                                label="Email"
                                variant="outlined"
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item>
                            <FormField
                                name="endereco"
                                type="text"
                                label="Endereço"
                                variant="outlined"
                                fullWidth
                                required
                            />
                        </Grid>
                    </Grid>

                    <Container>
                        <Button
                            className={classes.submitButton}
                            type="submit"
                            variant="contained"
                            disabled={loading}
                        >
                            {loading ? loadingElement() : submitBtnTitle()}
                        </Button>
                    </Container>
                </Form>
            )}</Formik>
        </Box>
    )
}
const mapStateToProps = ({ manufacturer }) => ({ manufacturer })
const mapDispatchToProps = dispatch => {
    const { createManufacturer, updateManufacturer } = ManufacturerActions
    return bindActionCreators({
        createManufacturer, updateManufacturer
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ProviderRegister);

